import React from 'react'
import PropTypes from 'prop-types'
import purifyHTML from '../../../utils/purifyHTML';

const Paragraph = (props) => {
  const { text = '' } = props.config
  return (
    <div className="field" dangerouslySetInnerHTML={purifyHTML(text)} />
  )
}

Paragraph.propTypes = {
  config: PropTypes.object.isRequired
}

export default Paragraph


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Paragraph.js